export function RecordingIndicator() {
  return (
    <div
      className="recording-indicator"
      role="status"
      aria-live="polite"
      aria-label="Recording"
    >
      <span className="recording-dot" aria-hidden="true"></span>
      <span className="sr-only">Recording…</span>
    </div>
  );
}
